import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { base64StringToBlob } from 'blob-util'
import { ToastService } from 'src/app/core/services/toast-service.service';

@Component({
  selector: 'app-photo-camera-modal',
  templateUrl: './photo-camera-modal.component.html',
  styleUrls: ['./photo-camera-modal.component.scss']
})

export class PhotoCameraModalComponent {
  public trigger: Subject<void> = new Subject<void>();
  public webcamImage?: WebcamImage;
  public loading: boolean = false;

  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 400 },
    height: { ideal: 400 }
  };


  constructor(
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
  ) {

  }


  getBlobFromWebcamImage() {
    const base64Data = this.webcamImage!.imageAsBase64;
    return base64StringToBlob(base64Data);
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      this.triggerSnapshot()
    }
  }

  public clearSnapshot(): void {
    this.webcamImage = undefined;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
  }
}
